(function () {
  const MOBILE_BREAKPOINT = 750;

  function isMobile() {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }

  function getPopupContainer(select) {
    return select.closest('.product-form__input--popup');
  }

  function getModalForSelect(select) {
    const modalId = select.dataset.variantPickerModal;
    return modalId ? document.getElementById(modalId) : null;
  }

  function syncTriggerValue(select) {
    if (!isMobile()) return;

    const container = getPopupContainer(select);
    if (!container) return;

    const triggerValue = container.querySelector('[data-variant-picker-value]');
    const selectedOption = select.options[select.selectedIndex];
    if (triggerValue && selectedOption) {
      triggerValue.textContent = selectedOption.value;
    }
  }

  function syncModalSelection(select, selectedValue) {
    const modal = getModalForSelect(select);
    if (!modal) return;

    const value = selectedValue ?? select.value;

    modal.querySelectorAll('.variant-picker-modal__option').forEach((option) => {
      const isSelected = option.dataset.value === value;
      option.classList.toggle('is-selected', isSelected);
      option.setAttribute('aria-selected', isSelected ? 'true' : 'false');
    });
  }

  function syncModalAvailability(select) {
    const modal = getModalForSelect(select);
    if (!modal) return;

    modal.querySelectorAll('.variant-picker-modal__option').forEach((button) => {
      const option = [...select.options].find((opt) => opt.value === button.dataset.value);
      const isDisabled = !option || option.disabled;

      button.classList.toggle('is-disabled', isDisabled);
      button.disabled = isDisabled;
    });
  }

  function selectVariantOption(button) {
    if (!isMobile()) return;
    if (button.disabled || button.classList.contains('is-disabled')) return;

    const select = document.getElementById(button.dataset.selectId);
    if (!select) return;

    select.value = button.dataset.value;
    if (select.value !== button.dataset.value) return;

    select.dispatchEvent(new Event('change', { bubbles: true }));

    syncTriggerValue(select);
    syncModalSelection(select, button.dataset.value);
    syncModalAvailability(select);

    button.closest('modal-dialog')?.hide();
  }

  function initVariantPickerPopups() {
    document.querySelectorAll('.variant-picker-select').forEach((select) => {
      syncTriggerValue(select);
      syncModalSelection(select);
      syncModalAvailability(select);
    });
  }

  document.addEventListener('click', (event) => {
    const optionButton = event.target.closest('.variant-picker-modal__option');
    if (optionButton) {
      selectVariantOption(optionButton);
      return;
    }

    const trigger = event.target.closest('.variant-picker-trigger');
    if (trigger && isMobile()) {
      const select = trigger.closest('.product-form__input--popup')?.querySelector('.variant-picker-select');
      if (select) {
        requestAnimationFrame(() => {
          syncModalSelection(select);
          syncModalAvailability(select);
        });
      }
    }
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('.variant-picker-select');
    if (!select) return;

    syncTriggerValue(select);
    syncModalSelection(select);
    syncModalAvailability(select);
  });

  window.addEventListener('resize', () => {
    if (!isMobile()) {
      document.querySelectorAll('modal-dialog.variant-picker-modal[open]').forEach((modal) => modal.hide());
    }
  });

  document.addEventListener('DOMContentLoaded', initVariantPickerPopups);
  document.addEventListener('shopify:section:load', initVariantPickerPopups);
})();